import { message } from 'antd'

// Configure message component globally
message.config({
  top: 120, // Position from top of the screen (below PhotoshopToolbar at 56px + toolbar height ~50px)
  duration: 3, // Duration in seconds
  maxCount: 3, // Maximum number of messages shown at once
  rtl: false, // Right-to-left layout
  // Custom styles for different message types
  style: {
    marginTop: '120px',
    borderRadius: '0', // No border radius
    padding: '0', // No padding
    boxShadow: 'none', // No shadow
    border: 'none', // No border
    background: 'transparent', // Completely transparent background
  },
})

// Custom message functions with specific styles
export const showSuccessMessage = (content) => {
  message.success({
    content,
    style: {
      background: 'transparent', // Completely transparent background
      color: '#10b981', // Green text color
      fontWeight: 'bold', // Make text bold
      fontSize: '14px', // Slightly larger font
      textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // Simple shadow below text
      border: 'none', // No border
      padding: '0', // No padding
      margin: '0', // No margin
    },
    className: 'custom-message-no-box', // Custom class for additional styling
  })
}

export const showErrorMessage = (content) => {
  message.error({
    content,
    style: {
      background: 'transparent', // Completely transparent background
      color: '#ef4444', // Red text color
      fontWeight: 'bold', // Make text bold
      fontSize: '14px', // Slightly larger font
      textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // Simple shadow below text
      border: 'none', // No border
      padding: '0', // No padding
      margin: '0', // No margin
    },
    className: 'custom-message-no-box', // Custom class for additional styling
  })
}

export const showInfoMessage = (content) => {
  message.info({
    content,
    style: {
      background: 'transparent', // Completely transparent background
      color: '#3b82f6', // Blue text color
      fontWeight: 'bold', // Make text bold
      fontSize: '14px', // Slightly larger font
      textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // Simple shadow below text
      border: 'none', // No border
      padding: '0', // No padding
      margin: '0', // No margin
    },
    className: 'custom-message-no-box', // Custom class for additional styling
  })
}

export const showWarningMessage = (content) => {
  message.warning({
    content,
    style: {
      background: 'transparent', // Completely transparent background
      color: '#f59e0b', // Orange text color
      fontWeight: 'bold', // Make text bold
      fontSize: '14px', // Slightly larger font
      textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)', // Simple shadow below text
      border: 'none', // No border
      padding: '0', // No padding
      margin: '0', // No margin
    },
    className: 'custom-message-no-box', // Custom class for additional styling
  })
}

// Add global CSS to override Ant Design's default message styles
const style = document.createElement('style')
style.innerHTML = `
  .custom-message-no-box .ant-message-notice-content {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    border: none !important;
  }
  
  .custom-message-no-box .ant-message-custom-content {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    border: none !important;
  }
`
document.head.appendChild(style)

export default message
